import { TranscriptStatus, TRANSCRIPT_IN_PROGRESS_STATUSES } from "@/constants";

export function isTranscriptionInProgress(
  status: TranscriptStatus | null | undefined
): boolean {
  return (
    !!status &&
    (TRANSCRIPT_IN_PROGRESS_STATUSES as readonly TranscriptStatus[]).includes(
      status
    )
  );
}
